// extracted by mini-css-extract-plugin
export default {"action_btn":"releaseVNModal_action_btn__hYisI","modal":"releaseVNModal_modal__hpaIc"};